export const typeOfExportModal = 'typeOfExportModal';
export const exportModalReducerKey = 'exportModalReducerKey';

export const exportModalSetIsLoadingReducerType = 'exportModalSetIsLoadingReducerType';
export const exportModalSetCurrentViewReducerType = 'exportModalSetCurrentViewReducerType';
export const exportModalSetErrorsReducerType = 'exportModalSetErrorsReducerType';
export const exportModalSetEntriesReducerType = 'exportModalSetEntriesReducerType';
export const exportModalSetDataReducerType = 'exportModalSetDataReducerType';
export const exportModalSetFormDataReducerType = 'exportModalSetFormDataReducerType';
export const exportModalSetFormatsBackupReducerType = 'exportModalSetFormatsBackupReducerType';
export const exportModalSetExportTypeReducerType = 'exportModalSetExportTypeReducerType';
export const exportModalSetSelectedDatapointsReducerType = 'exportModalSetSelectedDatapointsReducerType';
export const exportModalResetStateReducerType = 'exportModalResetStateReducerType';

export const EXPORT_VIEWS = {
  MAIN: 1,
  DATAPOINTS: 2,
};

export const EXPORT_ERRORS = {
  FORM_ERROR: 'formError',
  FORMAT: 'format',
  RANGE_HIGH_ANONYMOUS_HINT: 'rangeHighAnonymousHint',
  RANGE_HIGH_BIOACTIVITY_VISUALIZATION: 'rangeHighBioactivityVisualizationTooltip',
  RANGE_HIGH: 'rangeHigh',
  RANGE_EMPTY: 'rangeEmpty',
  RANGE_FROM_TO: 'rangeFromTo',
};

export const SELECT_DATA_EXPORT_OPTION = 'contains:selected';
export const EXPORT_TERMS_AND_CONDITIONS_LINK =
  'https://www.elsevier.com/legal/elsevier-website-terms-and-conditions?dgcid=RN_AGCM_Sourced_300005028';
